import * as React from 'react';
import translate from '../../../../locale/translate';

import { NodeTagFilterEditor, NodeSystemFilterEditor } from '../../common/Editor';
import ISettings from './ISettings';
import { IInputChangeEventHandler } from '../../../../interfaces';
import { Tag } from '../../../../store/models';

import { getDisplayValue, formatDate } from '../../util/StringUtil';

interface IProps {
    data: { tags: Tag[] },
    settings: ISettings,
    handleChange: IInputChangeEventHandler,
}

export default class Editor extends React.Component<IProps, void> {
    handleChange(evt: React.ChangeEvent<HTMLInputElement>) {
        this.props.handleChange(evt.target.name, evt.target.value);
    }

    render() {
        const { settings, handleChange } = this.props;
        const now = new Date();

        return (
            <div>
                <h3>{translate.gettext('Filter')}</h3>

                <NodeTagFilterEditor {...this.props} />

                <h3>{translate.gettext("Calculation")}</h3>

                <div className="form-group">
                    <label>{translate.gettext("Threshold minutes short")}</label>
                    <input
                        type="number"
                        name="shortMinutes"
                        className="form-control"
                        value={settings.shortMinutes}
                        onChange={this.handleChange.bind(this)}
                    />
                </div>

                <div className="form-group">
                    <label>{translate.gettext("Threshold minutes long")}</label>
                    <input
                        type="number"
                        name="longMinutes"
                        className="form-control"
                        value={settings.longMinutes}
                        onChange={this.handleChange.bind(this)}
                    />
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/alerts/monitoringOverview/Editor.tsx